module.exports = __webpack_public_path__ + "static/img/two.4e4dc8a6.png";